
export default {
  'contact-us': {
    url: '/b/skypegmwcn/save-contact',
    method: 'post'
  },
  
}


// WEBPACK FOOTER //
// ./src/api/contact.js